module.exports = __webpack_public_path__ + "img/shil_mqxblljn4syn.ed5c7d6.png";